module.exports = __webpack_public_path__ + "img/man.541d7a64.png";